import { render } from "./Dollarbox.vue?vue&type=template&id=998b4650&bindings={\"modelValue\":\"props\",\"readonly\":\"props\",\"type\":\"props\",\"localValue\":\"data\",\"formatCurrency\":\"options\",\"formatPercent\":\"options\",\"value\":\"options\"}"
import script from "./Dollarbox.vue?vue&type=script&lang=js"
export * from "./Dollarbox.vue?vue&type=script&lang=js"
script.render = render

export default script